<template>
<div class="row clearfix">
  <div v-if="loading">
    <BlockUI :message="blockuimsg"></BlockUI>
  </div>
  <div class="card">
    <div class="body">
    <div class="col-lg-12">
      <exercises ref="exercise_child" :exercise="exercise" :engine="engine"></exercises>
      <br>
      <ValidationObserver ref="formValidation">
        <div class="row">
            <div class="col-md-4"> <strong>Configuracion</strong>
                <br/>
                <div>
                  Tipo Actividad<select class="form-control" v-model="configuration.TIPO_ACTIVIDAD" @change="resetModifications()">
                    <option value="1">(1) Correspondencia de representación de hora en analógico y digital</option>
                    <option value="2">(2) Nomenclatura de los periodos del día</option>
                    <option value="3">(3) Nomenclatura de los minutos de la hora</option>
                    <option value="4">(4) Tiempo transcurrido entre dos horas</option>
                    <option value="5">(5) Adelantar/Retrasar reloj</option>
                  </select>
                </div>
                <br/>
                <div>
                  Respuesta 1<select class="form-control" v-model="configuration.RESPUESTA_PREGUNTA_1">
                    <option value="0">(0) Preguntar por: antes o despues del mediodía</option>
                    <option value="1">(1) Preguntar por: antes o despues del medianoche</option>
                    <option value="2">(2) Preguntar por: mediodía, medianoche u otra hora</option>
                    <option value="3">(3) Preguntar por: madrugada,mañana,mediodía,tarde, noche o medianoche</option>
                  </select>
                </div>
                <div>
                  Respuesta 2<select class="form-control" v-model="configuration.RESPUESTA_PREGUNTA_2">
                    <option value="0">(0) Preguntar por en punto, y media</option>
                    <option value="1">(1) Preguntar por en punto, y cuarto, y media, menos cuarto</option>
                    <option value="2">(2) Preguntar por en punto, y cinco, y diez, y cuarto, etc</option>
                  </select>
                </div>
                <br/>
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input"
                  v-model="configuration.INCLUIR_SEGUNDOS"
                  id="INCLUIR_SEGUNDOS">
                  <label class="custom-control-label" for="INCLUIR_SEGUNDOS">Incluir segundos</label>
                </div>
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input"
                  v-model="configuration.RESPUESTA_HORAS"
                  v-on:change="configuration.RESPUESTA_MINUTOS = false; configuration.RESPUESTA_SEGUNDOS = false"
                  id="res_horas">
                  <label class="custom-control-label" for="res_horas">Respuesta horas</label>
                </div>
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input"
                  v-model="configuration.RESPUESTA_MINUTOS"
                  v-on:change="configuration.RESPUESTA_SEGUNDOS = false"
                  :disabled="!configuration.RESPUESTA_HORAS"
                  id="res_min">
                  <label class="custom-control-label" for="res_min">Respuesta minutos</label>
                </div>
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input"
                  v-model="configuration.RESPUESTA_SEGUNDOS"
                  :disabled="!configuration.RESPUESTA_MINUTOS"
                  id="res_sec">
                  <label class="custom-control-label" for="res_sec">Respuesta segundos</label>
                </div>
                <br/>
                <div>
                  Tipo respuesta<select class="form-control" v-model="configuration.RESPUESTA_RELOJ">
                    <option value="0">Analogico</option>
                    <option value="1">Digital</option>
                  </select>
                </div>
                <div class="custom-control custom-checkbox" v-if="parseInt(configuration.RESPUESTA_RELOJ) === 0">
                  <input type="checkbox" class="custom-control-input"
                  v-model="configuration.RESPUESTA_ANALOGICO_NOMENCLATURA_MINUTOS"
                  id="res_analog_nom">
                  <label class="custom-control-label" for="res_analog_nom">Respuesta nomenclatura minutos</label>
                </div>
                <div class="custom-control custom-checkbox" v-if="parseInt(configuration.RESPUESTA_RELOJ) === 0">
                  <input type="checkbox" class="custom-control-input"
                  v-model="configuration.RESPUESTA_ANALOGICO_NUMEROS_ESFERA"
                  id="res_analog_numesf">
                  <label class="custom-control-label" for="res_analog_numesf">Respuesta números esfera</label>
                </div>
                <div class="custom-control custom-checkbox" v-if="parseInt(configuration.RESPUESTA_RELOJ) === 0">
                  <input type="checkbox" class="custom-control-input"
                  v-model="configuration.RESPUESTA_ANALOGICO_MINUTOS"
                  id="res_analog_min">
                  <label class="custom-control-label" for="res_analog_min">Respuesta analogico minutos</label>
                </div>
            </div>
              <div class="col-md-4"> <strong>Reloj Izquierda (A)</strong>
                <div>
                  Tipo reloj<select class="form-control" v-model="configuration.TIPO_RELOJ_A">
                    <option value="0">Analogico</option>
                    <option value="1">Digital</option>
                    <option value="2">Ambos</option>
                  </select>
                </div>
                <br />
                <!-- RELOJ A: Analogico -->
                <div class="custom-control custom-checkbox" v-if="parseInt(configuration.TIPO_RELOJ_A) !== 1">
                  <input type="checkbox" class="custom-control-input"
                  v-model="configuration.ANALOGICO_REPRESENTACION_GRAFICA_A"
                  id="a_analog_rep_grafica">
                  <label class="custom-control-label" for="a_analog_rep_grafica">Analogico representación gráfica</label>
                </div>
                <div class="custom-control custom-checkbox" v-if="parseInt(configuration.TIPO_RELOJ_A) !== 1">
                  <input type="checkbox" class="custom-control-input"
                  v-model="configuration.ANALOGICO_RG_NOMENCLATURA_MINUTOS_A"
                  id="a_analog_nom_minutos">
                  <label class="custom-control-label" for="a_analog_nom_minutos">Analogico nomenclatura minutos</label>
                  <br />
                  <small>(Según respuesta 2)</small>
                </div>
                <!--<div class="custom-control custom-checkbox" v-if="parseInt(configuration.TIPO_RELOJ_A) !== 1">
                  <input type="checkbox" class="custom-control-input"
                  v-model="configuration.ANALOGICO_RG_MINUTOS_A"
                  id="a_analog_rg_min">
                  <label class="custom-control-label" for="a_analog_rg_min">Analogico minutos esfera</label>
                </div>
                <div class="custom-control custom-checkbox" v-if="parseInt(configuration.TIPO_RELOJ_A) !== 1">
                  <input type="checkbox" class="custom-control-input"
                  v-model="configuration.ANALOGICO_RG_NUMEROS_ESFERA_A"
                  id="a_analog_num_esf">
                  <label class="custom-control-label" for="a_analog_num_esf">Analogico números esfera</label>
                </div>-->
                <br />
                <div class="custom-control custom-checkbox" v-if="parseInt(configuration.TIPO_RELOJ_A) !== 1">
                  <input type="checkbox" class="custom-control-input"
                  v-model="configuration.ANALOGICO_VERBAL_ORAL_A"
                  id="a_analog_oral">
                  <label class="custom-control-label" for="a_analog_oral">Analogico verbal oral</label>
                </div>
                <div class="custom-control custom-checkbox" v-if="parseInt(configuration.TIPO_RELOJ_A) !== 1 && configuration.ANALOGICO_VERBAL_ORAL_A">
                  Analogico tipo verbal oral<select class="form-control" v-model="configuration.ANALOGICO_TIPO_VERBAL_ORAL_A">
                    <option value="0">hora</option>
                    <option value="1">pm/am</option>
                    <option value="2">mañana/tarde/noche</option>
                  </select>
                </div>
                <div class="custom-control custom-checkbox" v-if="parseInt(configuration.TIPO_RELOJ_A) !== 1">
                  <input type="checkbox" class="custom-control-input"
                  v-model="configuration.ANALOGICO_VERBAL_ESCRITO_A"
                  id="a_analog_escrito">
                  <label class="custom-control-label" for="a_analog_escrito">Analogico verbal escrito</label>
                </div>
                <div class="custom-control custom-checkbox" v-if="parseInt(configuration.TIPO_RELOJ_A) !== 1 && configuration.ANALOGICO_VERBAL_ESCRITO_A">
                  Analogico tipo verbal escrito<select class="form-control" v-model="configuration.ANALOGICO_TIPO_VERBAL_ESCRITO_A">
                    <option value="0">hora</option>
                    <option value="1">pm/am</option>
                    <option value="2">mañana/tarde/noche</option>
                  </select>
                </div>
                <br />
                <!-- RELOJ A: Digital -->
                <div class="custom-control custom-checkbox" v-if="parseInt(configuration.TIPO_RELOJ_A) !== 0">
                  <input type="checkbox" class="custom-control-input"
                  v-model="configuration.DIGITAL_REPRESENTACION_GRAFICA_A"
                  id="a_digital_nom_minutos">
                  <label class="custom-control-label" for="a_digital_nom_minutos">Digital representación gráfica</label>
                </div>
                <div class="custom-control custom-checkbox" v-if="parseInt(configuration.TIPO_RELOJ_A) !== 0">
                  <input type="checkbox" class="custom-control-input"
                  v-model="configuration.DIGITAL_VERBAL_ORAL_A"
                  id="a_digital_oral">
                  <label class="custom-control-label" for="a_digital_oral">Digital verbal oral</label>
                </div>
                <div class="custom-control custom-checkbox" v-if="parseInt(configuration.TIPO_RELOJ_A) !== 0">
                  <input type="checkbox" class="custom-control-input"
                  v-model="configuration.DIGITAL_VERBAL_ESCRITO_A"
                  id="a_digital_escrito">
                  <label class="custom-control-label" for="a_digital_escrito">Digital verbal escrito</label>
                </div>
              </div>
              <div class="col-md-4"> <strong>Reloj Derecha (B)</strong>
                <div>
                  Tipo reloj<select class="form-control" v-model="configuration.TIPO_RELOJ_B">
                    <option value="0">Analogico</option>
                    <option value="1">Digital</option>
                    <option value="2">Ambos</option>
                  </select>
                </div>
                <br />
                <!-- RELOJ B: Analogico -->
                <div class="custom-control custom-checkbox" v-if="parseInt(configuration.TIPO_RELOJ_B) !== 1">
                  <input type="checkbox" class="custom-control-input"
                  v-model="configuration.ANALOGICO_REPRESENTACION_GRAFICA_B"
                  id="b_analog_rep_grafica">
                  <label class="custom-control-label" for="b_analog_rep_grafica">Analogico representación gráfica</label>
                </div>
                <div class="custom-control custom-checkbox" v-if="parseInt(configuration.TIPO_RELOJ_B) !== 1">
                  <input type="checkbox" class="custom-control-input"
                  v-model="configuration.ANALOGICO_RG_NOMENCLATURA_MINUTOS_B"
                  id="b_analog_nom_minutos">
                  <label class="custom-control-label" for="b_analog_nom_minutos">Analogico nomenclatura minutos</label>
                  <br />
                  <small>(Según respuesta 2)</small>
                </div>
                <!--<div class="custom-control custom-checkbox" v-if="parseInt(configuration.TIPO_RELOJ_B) !== 1">
                  <input type="checkbox" class="custom-control-input"
                  v-model="configuration.ANALOGICO_RG_MINUTOS_B"
                  id="b_analog_rg_min">
                  <label class="custom-control-label" for="b_analog_rg_min">Analogico minutos esfera</label>
                </div>
                <div class="custom-control custom-checkbox" v-if="parseInt(configuration.TIPO_RELOJ_B) !== 1">
                  <input type="checkbox" class="custom-control-input"
                  v-model="configuration.ANALOGICO_RG_NUMEROS_ESFERA_B"
                  id="b_analog_num_esf">
                  <label class="custom-control-label" for="b_analog_num_esf">Analogico números esfera</label>
                </div>-->
                <br />
                <div class="custom-control custom-checkbox" v-if="parseInt(configuration.TIPO_RELOJ_B) !== 1">
                  <input type="checkbox" class="custom-control-input"
                  v-model="configuration.ANALOGICO_VERBAL_ORAL_B"
                  id="b_analog_oral">
                  <label class="custom-control-label" for="b_analog_oral">Analogico verbal oral</label>
                </div>
                <div class="custom-control custom-checkbox" v-if="parseInt(configuration.TIPO_RELOJ_B) !== 1 && configuration.ANALOGICO_VERBAL_ORAL_B">
                  Analogico tipo verbal oral<select class="form-control" v-model="configuration.ANALOGICO_TIPO_VERBAL_ORAL_B">
                    <option value="0">hora</option>
                    <option value="1">pm/am</option>
                    <option value="2">mañana/tarde/noche</option>
                  </select>
                </div>
                <div class="custom-control custom-checkbox" v-if="parseInt(configuration.TIPO_RELOJ_B) !== 1">
                  <input type="checkbox" class="custom-control-input"
                  v-model="configuration.ANALOGICO_VERBAL_ESCRITO_B"
                  id="b_analog_escrito">
                  <label class="custom-control-label" for="b_analog_escrito">Analogico verbal escrito</label>
                </div>
                <div class="custom-control custom-checkbox" v-if="parseInt(configuration.TIPO_RELOJ_B) !== 1 && configuration.ANALOGICO_VERBAL_ORAL_B">
                  Analogico tipo verbal escrito<select class="form-control" v-model="configuration.ANALOGICO_TIPO_VERBAL_ESCRITO_B">
                    <option value="0">hora</option>
                    <option value="1">pm/am</option>
                    <option value="2">mañana/tarde/noche</option>
                  </select>
                </div>
                <br />
                <!-- RELOJ B: Digital -->
                <div class="custom-control custom-checkbox" v-if="parseInt(configuration.TIPO_RELOJ_B) !== 0">
                  <input type="checkbox" class="custom-control-input"
                  v-model="configuration.DIGITAL_REPRESENTACION_GRAFICA_B"
                  id="b_digital_nom_minutos">
                  <label class="custom-control-label" for="b_digital_nom_minutos">Digital representación gráfica</label>
                </div>
                <div class="custom-control custom-checkbox" v-if="parseInt(configuration.TIPO_RELOJ_B) !== 0">
                  <input type="checkbox" class="custom-control-input"
                  v-model="configuration.DIGITAL_VERBAL_ORAL_B"
                  id="b_digital_oral">
                  <label class="custom-control-label" for="b_digital_oral">Digital verbal oral</label>
                </div>
                <div class="custom-control custom-checkbox" v-if="parseInt(configuration.TIPO_RELOJ_B) !== 0">
                  <input type="checkbox" class="custom-control-input"
                  v-model="configuration.DIGITAL_VERBAL_ESCRITO_B"
                  id="b_digital_escrito">
                  <label class="custom-control-label" for="b_digital_escrito">Digital verbal escrito</label>
                </div>
              </div>
        </div>
        <br>
        <hr>
        <b-row>
          <b-col style="text-align:center">
            <strong>Operaciones del ejercicio</strong>
            <b-button v-if="arrayEleOperation.length > 1" @click="removeArrayEleOperation()" class="btn btn-danger ml-2" size="sm">-</b-button>
            <b-button @click="addArrayEleOperation()" class="btn btn-primary ml-2" size="sm">+</b-button>
          </b-col>
        </b-row>
        <br>
        <b-row  class="justify-content-md-center">
            <b-col style="text-align:center"><h6>Hora</h6></b-col>
            <b-col style="text-align:center"><h6>Minutos</h6></b-col>
            <b-col style="text-align:center"><h6>Segundos</h6></b-col>
            <b-col style="text-align:center" v-if="parseInt(configuration.TIPO_ACTIVIDAD) === 4 || parseInt(configuration.TIPO_ACTIVIDAD) === 5"><h6>Mod. Horas</h6></b-col>
            <b-col style="text-align:center" v-if="parseInt(configuration.TIPO_ACTIVIDAD) === 4 || parseInt(configuration.TIPO_ACTIVIDAD) === 5"><h6>Mod. Minutos</h6></b-col>
            <b-col style="text-align:center" v-if="parseInt(configuration.TIPO_ACTIVIDAD) === 4 || parseInt(configuration.TIPO_ACTIVIDAD) === 5"><h6>Mod. Segundos</h6></b-col>
            <b-col style="text-align:center" v-if="parseInt(configuration.TIPO_ACTIVIDAD) === 4 || parseInt(configuration.TIPO_ACTIVIDAD) === 5"><h6>Adelantar</h6></b-col>
        </b-row>
        <div>
          <div v-for="(operation, index) in arrayEleOperation" v-bind:key="index">
              <b-row class="justify-content-md-center" style="margin-bottom: 10px">
                <b-col>
                  <ValidationProvider rules="required|between:0,24" v-slot="{ errors }">
                    <b-form-input type="number"
                      v-bind:id="'HORA_HORAS' + index"
                      v-model="arrayEleOperation[index].HORA_HORAS" />
                    <span class="validation-error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-col>
                <b-col>
                  <ValidationProvider rules="required|between:0,59" v-slot="{ errors }">
                    <b-form-input type="number"
                      v-bind:id="'HORA_MINUTOS' + index"
                      v-model="arrayEleOperation[index].HORA_MINUTOS" />
                    <span class="validation-error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-col>
                <b-col>
                  <ValidationProvider rules="required|between:0,59" v-slot="{ errors }">
                    <b-form-input type="number"
                      v-bind:id="'HORA_SEGUNDOS' + index"
                      v-model="arrayEleOperation[index].HORA_SEGUNDOS" />
                    <span class="validation-error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-col>
                <b-col v-if="parseInt(configuration.TIPO_ACTIVIDAD) === 4 || parseInt(configuration.TIPO_ACTIVIDAD) === 5">
                  <ValidationProvider rules="required" v-slot="{ errors }">
                    <b-form-input type="number"
                      v-bind:id="'MODIFICACION_HORAS' + index"
                      v-model="arrayEleOperation[index].MODIFICACION_HORAS" />
                    <span class="validation-error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-col>
                <b-col v-if="parseInt(configuration.TIPO_ACTIVIDAD) === 4 || parseInt(configuration.TIPO_ACTIVIDAD) === 5">
                  <ValidationProvider rules="required" v-slot="{ errors }">
                    <b-form-input type="number"
                      v-bind:id="'MODIFICACION_MINUTOS' + index"
                      v-model="arrayEleOperation[index].MODIFICACION_MINUTOS" />
                    <span class="validation-error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-col>
                <b-col v-if="parseInt(configuration.TIPO_ACTIVIDAD) === 4 || parseInt(configuration.TIPO_ACTIVIDAD) === 5">
                  <ValidationProvider rules="required" v-slot="{ errors }">
                    <b-form-input type="number"
                      v-bind:id="'MODIFICACION_SEGUNDOS' + index"
                      v-model="arrayEleOperation[index].MODIFICACION_SEGUNDOS" />
                    <span class="validation-error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-col>
                <b-col v-if="parseInt(configuration.TIPO_ACTIVIDAD) === 4 || parseInt(configuration.TIPO_ACTIVIDAD) === 5">
                  <select class="form-control" v-model="arrayEleOperation[index].VARIACION">
                    <option value="0">Adelantar</option>
                    <option value="1" v-if="parseInt(configuration.TIPO_ACTIVIDAD) === 5">Atrasar</option>
                  </select>
                </b-col>
            </b-row>
          </div>
        </div>
        <br>
        <b-row>
          <b-col class="text-center">
            <button v-on:click="saveStorage" :disabled="arrayEleOperation.length < 1" class="btn btn-info btn-lg">
            Guardar
          </button>
          </b-col>
        </b-row>
      </ValidationObserver>
    </div>
    </div>
  </div>
</div>
</template>

<script>
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required, between } from 'vee-validate/dist/rules';
import exercises from '../../exercises/exercise.vue';
import engineMixin from '../../../../mixins/engine';

extend('required', {
  ...required,
  message: 'Campo obligatorio.',
});
extend('between', {
  ...between,
  message: 'Entre {min} y {max}.',
});

export default {
  props: {
    engine: Number,
    exercise: Object,
    type: String,
  },
  mixins: [engineMixin],
  components: {
    exercises,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      arrayEleOperation: [],
      // Mapear con los campos de la tabla TIEMPO_CONF
      configuration: {
        ID: -1,
        TIPO_ACTIVIDAD: 1,
        INCLUIR_SEGUNDOS: false,
        TIPO_RELOJ_A: 0,
        ANALOGICO_REPRESENTACION_GRAFICA_A: true,
        ANALOGICO_RG_NOMENCLATURA_MINUTOS_A: false,
        ANALOGICO_RG_MINUTOS_A: false,
        ANALOGICO_RG_NUMEROS_ESFERA_A: false,
        ANALOGICO_VERBAL_ORAL_A: false,
        ANALOGICO_TIPO_VERBAL_ORAL_A: 0,
        ANALOGICO_VERBAL_ESCRITO_A: false,
        ANALOGICO_TIPO_VERBAL_ESCRITO_A: 0,
        DIGITAL_REPRESENTACION_GRAFICA_A: true,
        DIGITAL_VERBAL_ORAL_A: false,
        DIGITAL_VERBAL_ESCRITO_A: false,
        TIPO_RELOJ_B: 0,
        ANALOGICO_REPRESENTACION_GRAFICA_B: true,
        ANALOGICO_RG_NOMENCLATURA_MINUTOS_B: false,
        ANALOGICO_RG_MINUTOS_B: false,
        ANALOGICO_RG_NUMEROS_ESFERA_B: false,
        ANALOGICO_VERBAL_ORAL_B: false,
        ANALOGICO_TIPO_VERBAL_ORAL_B: 0,
        ANALOGICO_VERBAL_ESCRITO_B: false,
        ANALOGICO_TIPO_VERBAL_ESCRITO_B: 0,
        DIGITAL_REPRESENTACION_GRAFICA_B: true,
        DIGITAL_VERBAL_ORAL_B: false,
        DIGITAL_VERBAL_ESCRITO_B: false,
        RESPUESTA_HORAS: true,
        RESPUESTA_MINUTOS: true,
        RESPUESTA_SEGUNDOS: false,
        RESPUESTA_RELOJ: 0,
        RESPUESTA_ANALOGICO_NOMENCLATURA_MINUTOS: 0,
        RESPUESTA_ANALOGICO_MINUTOS: false,
        RESPUESTA_ANALOGICO_NUMEROS_ESFERA: 0,
        RESPUESTA_PREGUNTA_1: 0,
        RESPUESTA_PREGUNTA_2: 0,
        EJERCICIOS_ID: -1, //
      },
    };
  },
  methods: {
    removeArrayEleOperation() {
      this.arrayEleOperation.pop();
    },
    addArrayEleOperation() {
      this.arrayEleOperation.push({
        POSICION: this.arrayEleOperation.length + 1,
        HORA_HORAS: 0,
        HORA_MINUTOS: 0,
        HORA_SEGUNDOS: 0,
        MODIFICACION_HORAS: 0,
        MODIFICACION_MINUTOS: 0,
        MODIFICACION_SEGUNDOS: 0,
        VARIACION: '0',
      });
    },
    /**
    * @method resetModifications
    * @description hace reset de MODIFICACION_HORAS para las validaciones
    */
    resetModifications() {
      for (let i = 0; i < this.arrayEleOperation.length; i += 1) {
        this.arrayEleOperation[i].MODIFICACION_HORAS = 0;
        this.arrayEleOperation[i].MODIFICACION_MINUTOS = 0;
        this.arrayEleOperation[i].MODIFICACION_SEGUNDOS = 0;
        this.arrayEleOperation[i].VARIACION = '0';
      }
    },
    async getMotorData(id) {
      this.loading = true;

      try {
        const response = await this.axios.get('time/gettime', {
          params: {
            ejercicios_id: id,
          },
        });
        this.configuration = response.data.config;
        response.data.elements.forEach((element) => {
          this.arrayEleOperation.push({
            POSICION: element.POSICION,
            HORA_HORAS: element.HORA_HORAS,
            HORA_MINUTOS: element.HORA_MINUTOS,
            HORA_SEGUNDOS: element.HORA_SEGUNDOS,
            MODIFICACION_HORAS: element.MODIFICACION_HORAS,
            MODIFICACION_MINUTOS: element.MODIFICACION_MINUTOS,
            MODIFICACION_SEGUNDOS: element.MODIFICACION_SEGUNDOS,
            VARIACION: element.VARIACION,
          });
        });
      } catch (e) {
        this.$toasted.show('Ocurrió un error al leer el ejercicio', { type: 'warning' });
      }

      this.loading = false;
    },
  },
  async mounted() {
    if (this.exercise !== null && (this.exercise.ID !== null && this.exercise.ID !== undefined)) {
      await this.getMotorData(this.exercise.ID);
    }
    // Read from storage data
    this.readFromStorage(this.type);
    this.updatedNumOperation();
  },
};
</script>
